import React, { useRef } from 'react'
import { Modal } from '@amzn/storm-ui'
import { ModalContainer, CloseButton, CloseIcon, HeaderContainer, Container, Headline, ModalStyle } from './style'
import { useEmitInitialRender } from '../../../utils/hooks'
import { FeatureModalNoData } from '../commons'
import { FeatureModalContent } from './components/FeatureModalContent'
import { useFeatureContext } from '../../../contexts/FeatureContext'
import { taktId } from '../../../utils/takt'
import { WidgetTypes } from '../../../common/constants'

export const DesktopFeatureModal: React.VFC = () => {
  const { featureKeys, featureOpen, featureLabels, featureCloseEvent } = useFeatureContext()
  useEmitInitialRender(WidgetTypes.FeatureModalDesktop)

  const buttonRef = useRef<HTMLButtonElement | null>(null)
  const containsData = featureKeys && featureKeys.length > 0
  const dataTaktId = taktId(WidgetTypes.WhatsNewCenter, 'FITManager')

  return (
    <>
      <ModalStyle />
      <Modal
        data-takt-id={dataTaktId}
        isOpen={featureOpen}
        onClose={featureCloseEvent}
        hasCloseButton={false}
        modalElementId="FITManager"
        padding="none"
        toggleEl={buttonRef.current === null ? undefined : buttonRef.current}
      >
        <ModalContainer>
          <HeaderContainer>
            <Headline type="h1" color="primary">
              {featureLabels?.whatsNew}
            </Headline>
            <CloseButton
              onClick={featureCloseEvent}
              buttonRef={(element) => {
                buttonRef.current = element
              }}
              data-ccx-e2e-id="aac-ftu-modal-close"
              data-takt-id={`${dataTaktId}_close-button`}
            >
              <CloseIcon type="times" />
            </CloseButton>
          </HeaderContainer>
          <Container variant={containsData ? 'white' : 'ccxEmptyGrey'}>{containsData ? <FeatureModalContent /> : <FeatureModalNoData />}</Container>
        </ModalContainer>
      </Modal>
    </>
  )
}
